// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"bex_a bik_rj bik_rk bik_vh bik_eb bik_vf bik_gs bik_kh"};